import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useEffect, useState } from "react";
import { perfilService } from "../services/PerfilService";
import { Perfil } from "../types/perfil/Perfil";

interface SelectPerfilProps {
  value?: string;
  onChange: (perfil?: Perfil) => void;
  label?: string;
  fullWidth?: boolean;
  sx?: any;
  required?: boolean;
  error?: boolean;
  helperText?: string;
}

const SelectPerfil = ({
  value,
  onChange,
  label = "Perfil de Acesso",
  fullWidth = true,
  sx = {},
  required = false,
  error = false,
  helperText = ""
}: SelectPerfilProps) => {
  const [perfis, setPerfis] = useState<Perfil[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPerfis = async () => {
      setLoading(true);
      try {
        const data = await perfilService.buscarPerfisAtivos();
        setPerfis(data);
      } catch (error) {
        console.error("Erro ao buscar perfis:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPerfis();
  }, []);

  const handleChange = (event: SelectChangeEvent) => {
    const guid = event.target.value;
    const selectedPerfil = perfis.find(perfil => perfil.guid === guid);
    onChange(selectedPerfil);
  };

  return (
    <FormControl 
      fullWidth={fullWidth} 
      sx={sx} 
      disabled={loading}
      error={error}
      required={required}
    >
      <InputLabel id="perfil-label">{label}</InputLabel>
      <Select
        labelId="perfil-label"
        id="perfil"
        value={value || ''}
        label={label}
        onChange={handleChange}
        error={error}
      >
        <MenuItem value="">
          <em>Selecione um perfil</em>
        </MenuItem>
        {perfis.map((perfil) => (
          <MenuItem key={perfil.guid} value={perfil.guid}>
            {perfil.nome}
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <div style={{ 
          color: error ? '#d32f2f' : 'rgba(0, 0, 0, 0.6)', 
          fontSize: '0.75rem', 
          marginTop: '3px' 
        }}>
          {helperText}
        </div>
      )}
    </FormControl>
  );
};

export default SelectPerfil;